import React, { useState } from 'react';
import ProcessTimesOut from 'assets/icons/process_times_out.svg';
import './verificationScreen.scss';
import { InputText } from 'components/inputText/inputText';
import { HtmlText, formatText } from 'core/i18n';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { getGenerateOtp } from '../helper/modalOtpUniversia.helper';
import AlertError from './components/alertError';

const MAX_ATTEMPS = 3;

export function VerificationScreen(props) {
    const [numberAttempts, setNumberAttempts] = useState(0);
    const {
        setToggleSnackBar,
        userProfile,
        showErrorTexts,
        errorTexts,
        userProfileForm,
        formActions,
        setButtonValidation,
        passText,
    } = props;
    const { id } = useParams();

    const handleClick = async () => {
        if (numberAttempts === MAX_ATTEMPS) {
            return;
        }
        setNumberAttempts(prevState => prevState + 1);
        await getGenerateOtp({ id, passText });
        setToggleSnackBar(true);
        setTimeout(() => {
            setToggleSnackBar(false);
        }, 2400);
    };

    return (
        <div className="verification-container">
            <img className="verification-img" src={ProcessTimesOut} alt="proccess_times_out" />
            <p>{formatText('modalWelcome-text', [userProfile.cellPhoneFix])}</p>
            <InputText
                label={formatText('modalWelcome-otpTitle')}
                messagesError={{
                    valid: formatText('modalWelcome-otpIncorrect'),
                    required: formatText('modalWelcome-otpIncorrect'),
                }}
                profileModel="userProfile.universiaName"
                placeholder={formatText('placeholder-otp')}
                type="text"
                name={'userProfile.universiaName'}
                isNotValidated={() => setButtonValidation(true)}
                isValidated={() => setButtonValidation(false)}
                userProfileForm={userProfileForm}
                userProfile={userProfile}
                uppercaseText={true}
                maxLength="6"
                validations={{
                    required: value => (value && value.length) || value.length <= 6,
                }}
                formActions={formActions}
            />

            {
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
                <p className="verification-text-retry">
                    {HtmlText(formatText('modalWelcome-otpRequestRetry'))}
                    <span>
                        <a onClick={handleClick} className="verification-text-link">
                            {HtmlText(formatText('modalWelcome-otpRetry'))}
                        </a>
                    </span>
                    <span>{HtmlText(formatText('modalWelcome-otpRetryPhone'))}</span>
                </p>
            }
            {showErrorTexts && <AlertError title={errorTexts.title} description={errorTexts.description} />}
        </div>
    );
}
